import { ArrowDownWideNarrow } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { SORT_OPTIONS, type SortKey } from '@/lib/sort'
import { useSortPreference } from '@/hooks/use-sort-preference'

/** Sort picker bound to the URL ?sort= preference. Default ("Order") shows no
 *  qualifier; any other choice labels the button so the active sort is visible. */
export function SortMenu() {
  const [sort, setSort] = useSortPreference()
  const active = SORT_OPTIONS.find((o) => o.key === sort)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-6 gap-1 px-2 text-[11px]"
          aria-label={`Sort: ${active?.label ?? 'Order'}`}
        >
          <ArrowDownWideNarrow className="size-3.5" />
          {sort === 'order' ? 'Sort' : <span className="font-medium">{active?.label}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup value={sort} onValueChange={(v) => setSort(v as SortKey)}>
          {SORT_OPTIONS.map((o) => (
            <DropdownMenuRadioItem key={o.key} value={o.key} className="text-xs">
              {o.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
